import { type MemberOnboardingMemberPlanChangesProps, type MemberOnboardingRestrictions } from 'utils/web_api.schemas'

import { DentalPlanChangesTable } from '../PlanChangesTable/DentalPlanChangesTable'
import { MedicalPlanChangesTable } from '../PlanChangesTable/MedicalPlanChangesTable'
import { VisionPlanChangesTable } from '../PlanChangesTable/VisionPlanChangesTable'

export interface PlanDetailsSectionProps {
  planChangeSummary: MemberOnboardingMemberPlanChangesProps;
  hasFamily: boolean;
  medicalPlanNoPlanMessage?: string;
  restrictions?: MemberOnboardingRestrictions;
}

export const PlanDetailsSection = ({
  planChangeSummary,
  hasFamily,
  restrictions = {},
  medicalPlanNoPlanMessage,
}: PlanDetailsSectionProps) => {
  return (
    <div data-testid='plan-details-section'>
      <div className='mb-10'>
        <h1 className='heading-lg text-gray-800 mb-3'>
          Plan Changes for {planChangeSummary.next_plan_year.plan_year}
        </h1>
        <p className='body text-gray-500'>
          Your insurance coverage can vary from year to year, which may also
          impact your overall healthcare costs.
        </p>
      </div>
      <div className='flex flex-col gap-8'>
        <MedicalPlanChangesTable
          planChangeSummary={planChangeSummary}
          hasFamily={hasFamily}
          thereIsNoNextPlanMessage={medicalPlanNoPlanMessage}
        />
        <DentalPlanChangesTable
          planChangeSummary={planChangeSummary}
          hasFamily={hasFamily}
          restrictions={restrictions}
        />
        <VisionPlanChangesTable
          planChangeSummary={planChangeSummary}
          restrictions={restrictions}
        />
      </div>
    </div>
  )
}
